import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_btn = _resolveComponent("v-btn");
    const _component_v_container = _resolveComponent("v-container");
    const _component_LocationListRow = _resolveComponent("LocationListRow");
    const _component_v_table = _resolveComponent("v-table");
    return (_openBlock(), _createBlock(_component_v_container, { class: "d-flex flex-wrap ma-0" }, {
        default: _withCtx(() => [
            _createVNode(_component_v_container, { class: "d-flex v-col-12 justify-start" }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                        "data-cy": "create",
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$router.push('/admin/locations/new')))
                    }, {
                        default: _withCtx(() => _cache[1] || (_cache[1] = [
                            _createTextVNode("Neue Location anlegen")
                        ])),
                        _: 1
                    })
                ]),
                _: 1
            }),
            _createVNode(_component_v_container, null, {
                default: _withCtx(() => [
                    _createVNode(_component_v_table, null, {
                        default: _withCtx(() => [
                            _cache[2] || (_cache[2] = _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    _createElementVNode("th", null, "ID"),
                                    _createElementVNode("th", null, "Location")
                                ])
                            ], -1)),
                            _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locations, (location, index) => {
                                    return (_openBlock(), _createBlock(_component_LocationListRow, {
                                        class: "cursor-pointer",
                                        key: index,
                                        location: location,
                                        onClick: ($event) => (_ctx.rowClick(location)),
                                        "data-cy": "locationRow"
                                    }, null, 8, ["location", "onClick"]));
                                }), 128))
                            ])
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            })
        ]),
        _: 1
    }));
}
